<template>
    <div class="flow-bread-crumb" :key="$_.get($_.last(navigation.parentFlows), 'id')">
        <div v-if="navigation.parentFlows.length" class="breadcrumb-container">
            <div class="item">
                <a-icon type="home" @click="navigateAndFocus()" style="font-size: 20px" />
                <span class="divider"> > </span>
            </div>

            <div
                v-for="item in $_.reverse(navigation.parentFlows)"
                :key="item.block.id"
                @click="navigateAndFocus(item.block)"
                class="item"
            >
                <span>{{ item.block.name || $t("chatbotv2.flow") }}</span>
                <span class="divider"> > </span>
            </div>
        </div>
        <div v-else class="title">
            <StoryTitle :storyTitle="automation.name" />
            <span class="text-primary" v-if="previewMode">(Preview Mode)</span>
            <span class="text-danger" v-if="previewMode">v:{{ automation.version }}</span>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import SYSTEM_PUBSUB from "../../../../../../../utils/systemPubSub";
import _ from "lodash";
import StoryTitle from "../AutomationTitle.vue";

const log = log2("FlowBreadCrumb");
export default {
    name: "FlowBreadCrumb",
    props: ["navigateTo", "navigation", "previewMode", "automation"],
    components: { StoryTitle },
    methods: {
        navigateAndFocus(block = this.automation.diagram) {
            const navigatingBlock = block === this.automation.diagram ? null : block;
            this.navigateTo(navigatingBlock);
            SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.CB_FOCUS_BLOCK, {
                blockId: _.get(block, "id"),
            });
        },
    },

    mounted() {
        // log("mounted", this.navigation);
    },
    watch: {
        navigation: {
            handler(val) {
                // log("navigation changed", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.flow-bread-crumb {
    position: absolute;
    top: 1rem;
    left: 1rem;
    z-index: 999;
    display: flex;
    gap: 6px;

    .title {
        color: #22272d;
        cursor: pointer;
        font-size: 24px;
        font-weight: 600;
        line-height: 31px;
        line-height: 30px;
        overflow: hidden !important;
        text-overflow: ellipsis;
        -webkit-transition: color 0.5s;
        transition: color 0.5s;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        white-space: nowrap;
    }

    .breadcrumb-container {
        background: #fff;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-radius: 4px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 40px;
        margin-right: 20px;
        max-width: 100%;
        overflow-y: auto;
        padding: 0 15px;
        pointer-events: all;
    }

    .item {
        color: #516173;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        justify-content: center;
        cursor: pointer;

        .divider {
            color: #9ba6b3;
            font-size: 15px;
            margin: 0 10px;
            cursor: none;
        }
    }

    .item:last-child .divider {
        display: none;
    }
}
</style>
